import { MetaEntry, WorkflowConfig, WorkflowStep } from '../lib/types'
import React, { useCallback, useEffect, useState } from 'react'
import { data as dataApi, tasks } from '../lib/api'
import DataEntrySummary from './data-entry'
import { useParams } from 'react-router-dom'
import { getWorkflowConfig } from '../workflows/util'
import ErrorMsg from '../components/error-msg'

type Props = {
    step: WorkflowStep
}

export default function InputStep(props: Props) {
    const { step } = props
    const { id } = useParams()
    const [config, setConfig] = useState<WorkflowConfig>()
    const [err, setErr] = useState('')

    useEffect(() => {
        getWorkflowConfig(Number(id))
            .then(setConfig)
            .catch((err) => setErr(err.message || err))
    }, [id])

    const indicatorFn = useCallback(
        (id: number, meta: MetaEntry) => {
            if (!config) return ''

            let time = new Date(meta.reviewFinished)
            if (time < config.start) return ''
            return meta.error ? 'red' : 'blue'
        },
        [config],
    )

    let loadData = step.taskBreakdown?.type === 'assign' ? tasks.list : dataApi.page

    let fields = step.view?.elements.map((e) => e.field! || e.target?.objIdField!).filter((_) => _)

    if (err) return <ErrorMsg error={err} />
    return (
        <DataEntrySummary
            loadData={loadData}
            canInsert={!!step.dataSource?.canInsert}
            indicatorFn={indicatorFn}
            fields={fields}
            idField={step.entityType?.idField}
        />
    )
}
